import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useApi } from '../hooks/useApi';
const ChangePasswordModal = ({ open, force, onClose, onChanged }) => {
    const { post } = useApi();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    if (!open) {
        return null;
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        try {
            setSubmitting(true);
            setError(null);
            await post('/auth/change-password', {
                currentPassword,
                newPassword
            });
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
            onChanged();
        }
        catch (err) {
            setError(err.message);
        }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsx("div", { className: "modal-backdrop", children: _jsxs("div", { className: "modal", children: [_jsx("h2", { children: "Update password" }), _jsx("p", { children: "Please choose a new password to continue." }), _jsxs("form", { onSubmit: handleSubmit, className: "content-grid", style: { gap: '1rem' }, children: [_jsxs("div", { children: [_jsx("label", { children: "Current password" }), _jsx("input", { type: "password", required: true, value: currentPassword, onChange: (event) => setCurrentPassword(event.target.value) })] }), _jsxs("div", { children: [_jsx("label", { children: "New password" }), _jsx("input", { type: "password", required: true, value: newPassword, onChange: (event) => setNewPassword(event.target.value) })] }), _jsxs("div", { children: [_jsx("label", { children: "Confirm password" }), _jsx("input", { type: "password", required: true, value: confirmPassword, onChange: (event) => setConfirmPassword(event.target.value) })] }), error && (_jsx("div", { style: { color: 'tomato', fontSize: '0.9rem' }, children: error })), _jsxs("div", { style: { display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }, children: [!force && (_jsx("button", { type: "button", onClick: onClose, style: { background: 'transparent', border: '1px solid var(--color-border)', color: 'var(--color-text)' }, children: "Cancel" })), _jsx("button", { type: "submit", disabled: isSubmitting, children: isSubmitting ? 'Saving...' : 'Save password' })] })] })] }) }));
};
export default ChangePasswordModal;
